import moment from 'moment';

const TextFormat = {
    FormatFullDateTime(date) {
        return moment(date).format('LLL');
    },
}

export default TextFormat;